/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-07 18:15:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 18:45:21
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/CreateButtonWithLanguageChangeWarning/tools.ts
 */
import { dispatch } from 'src/store';
import { modal } from '@/src/utils/Modal';
import { updateToPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';

const handleClick = (props: any) => {
  const {
    onClick,
    title,
    content,
    onOkText,
    onCancelText,
    salesChannelUuid,
    getI18n,
  } = props || {};
  const isPrimary = isCurrentPrimary();
  if (isPrimary) {
    if (onClick) onClick();
  } else {
    modal.info({
      title,
      content,
      onOkText: onOkText || getI18n('general.antd.Uploader.ok'),
      onCancelText: onCancelText || getI18n('general.cancel'),
      onOk: () => {
        dispatch(updateToPrimaryLanguage({ salesChannelUuid }));
        if (onClick) onClick();
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  }
};
export { handleClick };
